import React from 'react';
import { ConferenceSubscriptionTrackerItem } from '../../../types/admin/subscriptionTracker';
import ConferenceDidHover from './ConferenceDidHover';

export type ConferenceSubRow = ConferenceSubscriptionTrackerItem & {
  sport_code: string;
};

interface ConferenceSubTableProps {
  conferences: ConferenceSubRow[];
  showSportColumn?: boolean;
  onViewTeams: (conference: ConferenceSubRow) => void;
}

const ConferenceSubTable: React.FC<ConferenceSubTableProps> = ({
  conferences,
  showSportColumn = false,
  onViewTeams,
}) => {
  if (conferences.length === 0) {
    return (
      <div className="text-center p-12 bg-gray-50 rounded-lg text-gray-500">
        No conferences match your filters.
      </div>
    );
  }

  return (
    <div className="overflow-x-auto border border-gray-200 rounded-lg">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            {showSportColumn && (
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Sport
              </th>
            )}
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Conference
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Subscribed / Total
            </th>
            <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              Action
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {conferences.map((conference) => (
            <tr
              key={`${conference.sport_code}:${conference.conference_name}`}
              className="hover:bg-gray-50"
            >
              {showSportColumn && (
                <td className="px-4 py-3 text-sm font-medium text-gray-800 whitespace-nowrap">
                  {conference.sport_code}
                </td>
              )}
              <td className="px-4 py-3">
                <div className="text-sm font-medium text-gray-900">{conference.conference_name}</div>
                {conference.conference_short_name &&
                  conference.conference_short_name !== conference.conference_name && (
                    <div className="text-xs text-gray-500">{conference.conference_short_name}</div>
                  )}
              </td>
              <td className="px-4 py-3 text-sm text-gray-700 whitespace-nowrap">
                <ConferenceDidHover
                  sportCode={conference.sport_code}
                  conferenceName={conference.conference_name}
                >
                  <span>
                    <span className="font-medium text-green-700">{conference.teams_did}</span>
                    <span className="text-gray-400"> / </span>
                    <span>{conference.teams_total}</span>
                  </span>
                </ConferenceDidHover>
              </td>
              <td className="px-4 py-3 text-right">
                <button
                  type="button"
                  onClick={() => onViewTeams(conference)}
                  className="px-3 py-1.5 text-sm text-blue-600 border border-blue-300 rounded-md hover:bg-blue-50"
                >
                  View teams
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ConferenceSubTable;
